import classNames from 'classnames'
import React from 'react'
import { PopoverInitialState } from 'reakit'

import { Icon, Select, SelectOption } from '../../../main/components'
import { HPSignalInterval, HP_SIGNAL_LABELS } from './types'

const IS_REDESIGN = FinvizSettings.hasRedesignEnabled
const OPTIONS = Object.entries(HP_SIGNAL_LABELS).map(([value, label]) => ({ value: value as HPSignalInterval, label }))
const POPOVER_SETTINGS: PopoverInitialState = {
  placement: 'bottom-end',
  unstable_offset: IS_REDESIGN ? [0, 0] : [4, 1],
}
const ROUNDING = IS_REDESIGN ? 'regular' : 'none'

type EliteSwitchProps = {
  isLoading: boolean
  signal: HPSignalInterval
  onSignalChange: (signals: HPSignalInterval) => void
}

export default function EliteSwitch({ isLoading, signal, onSignalChange }: EliteSwitchProps) {
  return (
    <>
      <Select
        aria-label="Signals interval"
        theme={IS_REDESIGN ? 'link' : 'transparent'}
        size={IS_REDESIGN ? 'xsmall' : 'xxsmall'}
        className={classNames({ 'text-link hover:underline': !IS_REDESIGN })}
        value={signal}
        items={OPTIONS}
        rightContent={<Icon name="chevronDown" width={IS_REDESIGN ? 16 : 14} />}
        onChange={({ value }) => {
          onSignalChange(value)
        }}
        listProps={{ direction: 'row', className: 'p-px', rounding: ROUNDING }}
        // override height defined by button to not stretch old hp signal tables
        style={IS_REDESIGN ? undefined : { height: 'auto' }}
        hasPopoverButtonWidthLimit={false}
        popoverStateSettings={POPOVER_SETTINGS}
        isLoading={isLoading}
        disabled={isLoading}
      >
        {OPTIONS.map((item) => (
          <SelectOption
            size="small"
            key={item.value}
            rounding={ROUNDING}
            activeTheme="chip"
            active={signal === item.value}
          >
            {item.label}
          </SelectOption>
        ))}
      </Select>
    </>
  )
}
